export default "__VITE_ASSET__B4m5Amsa__"